/**
  * Retrieves the value of a query string parameter from the current browser URL.
 *
 * @param variable - The name of the query parameter to retrieve.
 * @returns The decoded value of the query parameter if found, otherwise an empty string.
 *
 */
export function getQueryVariable(variable: string){
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (const var_pairs of vars) {
      const pair = var_pairs.split('=');
      if (decodeURIComponent(pair[0]) === variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return '';
  }

/**
 * Returns true if the current page is hosted inside a Microsoft Teams window/frame.
 * The heuristic used is that if the page is running in a nested frame (i.e. window.self !== window.top),
 * then it is probably running inside Teams. If the page throws an error when trying to access window.top,
 * then it is probably running inside Teams as well.
 * @returns {boolean} Whether the page is running inside Microsoft Teams.
 */
  export function inTeams(){
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

/**
 * Generates an abbreviation from a given username.
 * The abbreviation consists of the first letter of the first 
 * and last name, converted to uppercase.
 * 
 * @param username - A string representing the user's full name.
 * @returns A string containing the uppercase abbreviation.
 */
  export function getUsernameAbbreviation(username:string){
    let username_splited = username.split(' ');
    let last_index = username_splited.length - 1;
    let user_abbr = username_splited[0].substring(0,1) + username_splited[last_index].substring(0,1);
    return user_abbr.toUpperCase();
  }

/**
 * Extracts and returns the initials from a given user's name.
 * If the name contains two or more words, it returns the first letter
 * of the first and second words. If the name contains only one word,
 * it returns the first two letters of that word. The initials are
 * converted to uppercase.
 * 
 * @param user_name - A string representing the user's full name.
 * @returns A string containing the uppercase initials.
 */
  export function getUserInitials(user_name: string) {
    let initials = '';
    let user_name_split = user_name.split(' ');
    if (user_name_split.length >= 2) {
        initials = user_name_split[0].slice(0, 1) + user_name_split[1].slice(0, 1)
    }
    else {
        initials = user_name_split[0].slice(0, 2)
    }
    return initials.toUpperCase();
}
